const config = {
    conversationlistUrl: 'https://chat-dev.realgeeksai.com/conversationlist',
    conversationMetrics: 'https://chat-dev.realgeeksai.com/conversations/metrics',
  };
  
  export default config;
  